// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button_button__XiC1d {
  padding: 11px 16px;
  border-radius: 8px;
  border: 1px solid transparent;
  background: transparent;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: 0.25s color, 0.25s background, 0.25s border, 0.25s box-shadow;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.Button_buttonIcon__p\\+-IS {
  padding: 0;
}
.Button_button__XiC1d:disabled {
  cursor: default;
  pointer-events: none;
}
.Button_button__XiC1d:disabled, .Button_button__XiC1d:hover, .Button_button__XiC1d:active {
  box-shadow: none !important;
}
.Button_button__XiC1d.Button_sizeMedium__dI8jF {
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
}
.Button_button__XiC1d.Button_sizeSmall__3v5LR {
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
}
.Button_button__XiC1d.Button_variantContained__ncaz- {
  background: var(--bg);
  color: var(--text);
}
.Button_button__XiC1d.Button_variantSecondary__YmN\\+O {
  background: var(--bg);
  color: var(--text);
}
.Button_button__XiC1d.Button_variantText__5yCbU {
  background: var(--bg);
  color: var(--text);
}
.Button_button__XiC1d.Button_variantOutlined__fRNfA {
  background: var(--bg);
  color: var(--text);
  border: 1px solid var(--text);
}
.Button_button__XiC1d.Button_colorPrimary__D\\+JfR.Button_variantContained__ncaz- {
  --bg: #4778EE;
  --text: white;
  box-shadow: 0px 49px 20px rgba(71, 120, 238, 0.01), 0px 28px 17px rgba(71, 120, 238, 0.05), 0px 12px 12px rgba(71, 120, 238, 0.09), 0px 3px 7px rgba(71, 120, 238, 0.1), 0px 0px 0px rgba(71, 120, 238, 0.1);
}
.Button_button__XiC1d.Button_colorPrimary__D\\+JfR.Button_variantContained__ncaz-:disabled {
  --bg: #a4c2fc !important;
}
.Button_button__XiC1d.Button_colorPrimary__D\\+JfR.Button_variantContained__ncaz-:hover {
  --bg: #3667DD;
}
.Button_button__XiC1d.Button_colorPrimary__D\\+JfR.Button_variantContained__ncaz-:active {
  --bg: #2C5BCC;
}
.Button_button__XiC1d.Button_colorPrimary__D\\+JfR.Button_variantSecondary__YmN\\+O {
  --bg: #F7F7F7;
  --text: #272A36;
}
.Button_button__XiC1d.Button_colorPrimary__D\\+JfR.Button_variantSecondary__YmN\\+O:disabled {
  --bg: #EDEDED !important;
  --text: #8E8E93 !important;
}
.Button_button__XiC1d.Button_colorPrimary__D\\+JfR.Button_variantSecondary__YmN\\+O:hover {
  --bg: #EFEFEF;
}
.Button_button__XiC1d.Button_colorPrimary__D\\+JfR.Button_variantSecondary__YmN\\+O:active {
  --bg: #EAEAEA;
}
.Button_button__XiC1d.Button_colorPrimary__D\\+JfR.Button_variantText__5yCbU {
  --bg: transparent;
  --text: #4778EE;
}
.Button_button__XiC1d.Button_colorPrimary__D\\+JfR.Button_variantText__5yCbU:disabled {
  --text: rgba(71, 120, 238, 0.46) !important;
}
.Button_button__XiC1d.Button_colorPrimary__D\\+JfR.Button_variantText__5yCbU:hover {
  --text: #3667DD;
}
.Button_button__XiC1d.Button_colorPrimary__D\\+JfR.Button_variantText__5yCbU:active {
  --text: #2C5BCC;
}
.Button_button__XiC1d.Button_colorPrimary__D\\+JfR.Button_variantOutlined__fRNfA {
  --bg: transparent;
  --text: #4778EE;
}
.Button_button__XiC1d.Button_colorPrimary__D\\+JfR.Button_variantOutlined__fRNfA:disabled {
  --text: rgba(71, 120, 238, 0.46) !important;
}
.Button_button__XiC1d.Button_colorPrimary__D\\+JfR.Button_variantOutlined__fRNfA:hover {
  --text: #3667DD;
}
.Button_button__XiC1d.Button_colorPrimary__D\\+JfR.Button_variantOutlined__fRNfA:active {
  --text: #2C5BCC;
}
.Button_button__XiC1d.Button_colorDanger__1VuFS.Button_variantContained__ncaz- {
  --bg: #E23834;
  --text: white;
}
.Button_button__XiC1d.Button_colorDanger__1VuFS.Button_variantContained__ncaz-:disabled {
  --bg: #ff9ea0 !important;
}
.Button_button__XiC1d.Button_colorDanger__1VuFS.Button_variantContained__ncaz-:hover {
  --bg: #DB3632;
}
.Button_button__XiC1d.Button_colorDanger__1VuFS.Button_variantContained__ncaz-:active {
  --bg: #D13430;
}
.Button_button__XiC1d.Button_colorDanger__1VuFS.Button_variantSecondary__YmN\\+O {
  --bg: #F7F7F7;
  --text: #E23834;
}
.Button_button__XiC1d.Button_colorDanger__1VuFS.Button_variantSecondary__YmN\\+O:disabled {
  --bg: #EDEDED !important;
  --text: #F2A3A2 !important;
}
.Button_button__XiC1d.Button_colorDanger__1VuFS.Button_variantSecondary__YmN\\+O:hover {
  --bg: #EFEFEF;
  --text: #DB3632;
}
.Button_button__XiC1d.Button_colorDanger__1VuFS.Button_variantSecondary__YmN\\+O:active {
  --bg: #EAEAEA;
  --text: #D13430;
}
.Button_button__XiC1d.Button_colorDanger__1VuFS.Button_variantText__5yCbU {
  --bg: transparent;
  --text: #E23834;
}
.Button_button__XiC1d.Button_colorDanger__1VuFS.Button_variantText__5yCbU:disabled {
  --text: #F2A3A2 !important;
}
.Button_button__XiC1d.Button_colorDanger__1VuFS.Button_variantText__5yCbU:hover {
  --text: #DB3632;
}
.Button_button__XiC1d.Button_colorDanger__1VuFS.Button_variantText__5yCbU:active {
  --text: #D13430;
}
.Button_button__XiC1d.Button_colorDanger__1VuFS.Button_variantOutlined__fRNfA {
  --bg: transparent;
  --text: #E23834;
}
.Button_button__XiC1d.Button_colorDanger__1VuFS.Button_variantOutlined__fRNfA:disabled {
  --text: #F2A3A2 !important;
}
.Button_button__XiC1d.Button_colorDanger__1VuFS.Button_variantOutlined__fRNfA:hover {
  --text: #DB3632;
}
.Button_button__XiC1d.Button_colorDanger__1VuFS.Button_variantOutlined__fRNfA:active {
  --text: #D13430;
}
.Button_button__XiC1d.Button_colorMuted__rqjnq.Button_variantText__5yCbU {
  --bg: transparent;
  --text: #848488;
}
.Button_button__XiC1d.Button_colorMuted__rqjnq.Button_variantText__5yCbU:disabled {
  --text: #cbcbcd !important;
}
.Button_button__XiC1d.Button_colorMuted__rqjnq.Button_variantText__5yCbU:hover {
  --text: #848488;
}
.Button_button__XiC1d.Button_colorMuted__rqjnq.Button_variantText__5yCbU:active {
  --text: #7E7E83;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/buttons/Button/Button.module.scss","webpack://./src/assets/scss/mixins.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yEAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;ECbA,mBAAA;EACA,gBAAA;EACA,uBAAA;ADaF;AAEE;EACE,UAAA;AAAJ;AAGE;EACE,eAAA;EACA,oBAAA;AADJ;AAIE;EACE,2BAAA;AAFJ;AAMI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAJN;AAOI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AALN;AASE;EACE,qBAAA;EACA,kBAAA;AAPJ;AAUE;EACE,qBAAA;EACA,kBAAA;AARJ;AAWE;EACE,qBAAA;EACA,kBAAA;AATJ;AAYE;EACE,qBAAA;EACA,kBAAA;EACA,6BAAA;AAVJ;AAcI;EACE,aAAA;EACA,aAAA;EACA,4MAAA;AAZN;AAcM;EACE,wBAAA;AAZR;AAeM;EACE,aAAA;AAbR;AAgBM;EACE,aAAA;AAdR;AAkBI;EACE,aAAA;EACA,eAAA;AAhBN;AAkBM;EACE,wBAAA;EACA,0BAAA;AAhBR;AAmBM;EACE,aAAA;AAjBR;AAoBM;EACE,aAAA;AAlBR;AAsBI;EACE,iBAAA;EACA,eAAA;AApBN;AAsBM;EACE,2CAAA;AApBR;AAuBM;EACE,eAAA;AArBR;AAwBM;EACE,eAAA;AAtBR;AA0BI;EACE,iBAAA;EACA,eAAA;AAxBN;AA0BM;EACE,2CAAA;AAxBR;AA2BM;EACE,eAAA;AAzBR;AA4BM;EACE,eAAA;AA1BR;AAgCI;EACE,aAAA;EACA,aAAA;AA9BN;AAgCM;EACE,wBAAA;AA9BR;AAiCM;EACE,aAAA;AA/BR;AAkCM;EACE,aAAA;AAhCR;AAoCI;EACE,aAAA;EACA,eAAA;AAlCN;AAoCM;EACE,wBAAA;EACA,0BAAA;AAlCR;AAqCM;EACE,aAAA;EACA,eAAA;AAnCR;AAsCM;EACE,aAAA;EACA,eAAA;AApCR;AAwCI;EACE,iBAAA;EACA,eAAA;AAtCN;AAwCM;EACE,0BAAA;AAtCR;AAyCM;EACE,eAAA;AAvCR;AA0CM;EACE,eAAA;AAxCR;AA4CI;EACE,iBAAA;EACA,eAAA;AA1CN;AA4CM;EACE,0BAAA;AA1CR;AA6CM;EACE,eAAA;AA3CR;AA8CM;EACE,eAAA;AA5CR;AAmDI;EACE,iBAAA;EACA,eAAA;AAjDN;AAmDM;EACE,0BAAA;AAjDR;AAoDM;EACE,eAAA;AAlDR;AAqDM;EACE,eAAA;AAnDR","sourcesContent":["@import '@/assets/scss/mixins.scss';\n\n.button {\n  padding: 11px 16px;\n  border-radius: 8px;\n  border: 1px solid transparent;\n  background: transparent;\n  cursor: pointer;\n  user-select: none;\n  transition: 0.25s color, 0.25s background, 0.25s border, 0.25s box-shadow;\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n\n  @include ellipsis;\n\n  &Icon {\n    padding: 0;\n  }\n\n  &:disabled {\n    cursor: default;\n    pointer-events: none;\n  }\n\n  &:disabled, &:hover, &:active {\n    box-shadow: none !important;\n  }\n\n  &.size {\n    &Medium {\n      font-weight: 500;\n      font-size: 14px;\n      line-height: 16px;\n    }\n\n    &Small {\n      font-weight: 500;\n      font-size: 12px;\n      line-height: 14px;\n    }\n  }\n\n  &.variantContained {\n    background: var(--bg);\n    color: var(--text);\n  }\n\n  &.variantSecondary {\n    background: var(--bg);\n    color: var(--text);\n  }\n\n  &.variantText {\n    background: var(--bg);\n    color: var(--text);\n  }\n\n  &.variantOutlined {\n    background: var(--bg);\n    color: var(--text);\n    border: 1px solid var(--text);\n  }\n\n  &.colorPrimary {\n    &.variantContained {\n      --bg: #4778EE;\n      --text: white;\n      box-shadow: 0px 49px 20px rgba(71, 120, 238, 0.01), 0px 28px 17px rgba(71, 120, 238, 0.05), 0px 12px 12px rgba(71, 120, 238, 0.09), 0px 3px 7px rgba(71, 120, 238, 0.1), 0px 0px 0px rgba(71, 120, 238, 0.1);\n\n      &:disabled {\n        --bg: #a4c2fc !important;\n      }\n\n      &:hover {\n        --bg: #3667DD;\n      }\n\n      &:active {\n        --bg: #2C5BCC;\n      }\n    }\n\n    &.variantSecondary {\n      --bg: #F7F7F7;\n      --text: #272A36;\n\n      &:disabled {\n        --bg: #EDEDED !important;\n        --text: #8E8E93 !important;\n      }\n\n      &:hover {\n        --bg: #EFEFEF;\n      }\n\n      &:active {\n        --bg: #EAEAEA;\n      }\n    }\n\n    &.variantText {\n      --bg: transparent;\n      --text: #4778EE;\n\n      &:disabled {\n        --text: rgba(71, 120, 238, 0.46) !important;\n      }\n\n      &:hover {\n        --text: #3667DD;\n      }\n\n      &:active {\n        --text: #2C5BCC;\n      }\n    }\n\n    &.variantOutlined {\n      --bg: transparent;\n      --text: #4778EE;\n\n      &:disabled {\n        --text: rgba(71, 120, 238, 0.46) !important;\n      }\n\n      &:hover {\n        --text: #3667DD;\n      }\n\n      &:active {\n        --text: #2C5BCC;\n      }\n    }\n  }\n\n  &.colorDanger {\n    &.variantContained {\n      --bg: #E23834;\n      --text: white;\n\n      &:disabled {\n        --bg: #ff9ea0 !important;\n      }\n\n      &:hover {\n        --bg: #DB3632;\n      }\n\n      &:active {\n        --bg: #D13430;\n      }\n    }\n\n    &.variantSecondary {\n      --bg: #F7F7F7;\n      --text: #E23834;\n\n      &:disabled {\n        --bg: #EDEDED !important;\n        --text: #F2A3A2 !important;\n      }\n\n      &:hover {\n        --bg: #EFEFEF;\n        --text: #DB3632;\n      }\n\n      &:active {\n        --bg: #EAEAEA;\n        --text: #D13430;\n      }\n    }\n\n    &.variantText {\n      --bg: transparent;\n      --text: #E23834;\n\n      &:disabled {\n        --text: #F2A3A2 !important;\n      }\n\n      &:hover {\n        --text: #DB3632;\n      }\n\n      &:active {\n        --text: #D13430;\n      }\n    }\n\n    &.variantOutlined {\n      --bg: transparent;\n      --text: #E23834;\n\n      &:disabled {\n        --text: #F2A3A2 !important;\n      }\n\n      &:hover {\n        --text: #DB3632;\n      }\n\n      &:active {\n        --text: #D13430;\n      }\n    }\n  }\n\n\n  &.colorMuted {\n    &.variantText {\n      --bg: transparent;\n      --text: #848488;\n\n      &:disabled {\n        --text: #cbcbcd !important;\n      }\n\n      &:hover {\n        --text: #848488;\n      }\n\n      &:active {\n        --text: #7E7E83;\n      }\n    }\n  }\n\n  //&.colorMuted {\n  //  &.variantText {\n  //    --bg: transparent;\n  //    --text: #E23834;\n  //\n  //    &:disabled {\n  //      --text: #F2A3A2 !important;\n  //    }\n  //\n  //    &:hover {\n  //      --text: #DB3632;\n  //    }\n  //\n  //    &:active {\n  //      --text: #D13430;\n  //    }\n  //  }\n  //}\n}\n","@mixin ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n@mixin invisible-scroll {\n  overflow: -moz-scrollbars-none;\n  overflow: -moz-hidden-unscrollable;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n    width: 0 !important;\n    -ms-overflow-style: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `Button_button__XiC1d`,
	"buttonIcon": `Button_buttonIcon__p+-IS`,
	"sizeMedium": `Button_sizeMedium__dI8jF`,
	"sizeSmall": `Button_sizeSmall__3v5LR`,
	"variantContained": `Button_variantContained__ncaz-`,
	"variantSecondary": `Button_variantSecondary__YmN+O`,
	"variantText": `Button_variantText__5yCbU`,
	"variantOutlined": `Button_variantOutlined__fRNfA`,
	"colorPrimary": `Button_colorPrimary__D+JfR`,
	"colorDanger": `Button_colorDanger__1VuFS`,
	"colorMuted": `Button_colorMuted__rqjnq`
};
export default ___CSS_LOADER_EXPORT___;
